"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var storybook_2 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
function Card(_a) {
    var image = _a.image, title = _a.title, className = _a.className;
    return react_1.default.createElement("div", { className: storybook_2.Helpers.classNames('storybook-channels-card', className) },
        react_1.default.createElement(storybook_1.Channels.Thumbnail, { image: image }),
        react_1.default.createElement(storybook_1.Texts.Heading, { className: 'storybook-channels-card-title', type: 'h4' }, title));
}
exports.default = Card;
Card.propTypes = {
    image: prop_types_1.default.string,
    title: prop_types_1.default.string,
    className: prop_types_1.default.string
};
